import styled from 'styled-components'
import inconBreadcrumbRight from '../assets/img/icon-breadcrumb-right.svg'

export const Breadcrumb = styled.ul`
  margin-bottom: 10px;
  list-style-type: none;
  display: block;
  /* margin-block-start: 1em; */
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
`

export const BreadcrumbItem = styled.li`
  display: inline-block;
  font-size: 14px;
  opacity: 0.7;

  &:after {
    content: '';
    background: url(${inconBreadcrumbRight}) center no-repeat;
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-left: 5px;
    margin-right: 5px;
  }
  &:last-child {
    opacity: 1;
  }
  &:last-child:after {
    display: none;
  }
`
